import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

import { CommonInputProps, FormInputWrapper } from './FormInputInternals';
import { Input } from './Input';

interface FormNumberInputProps extends Omit<NumericFormatProps, 'name'>, CommonInputProps {
    placeholder: string;
    optional?: boolean;
}
export const FormNumberInput = ({
    name,
    label,
    description,
    vertical,
    placeholder,
    optional,
    disabled,
    hideLabel,
    onBlur: onCustomBlur,
    onFocus: onCustomFocus,
    ...numberFormatProps
}: FormNumberInputProps) => {
    return (
        <FormInputWrapper
            {...{ name, label, description, vertical, disabled, hideLabel }}
            fieldRenderer={({ field: { onChange, value, onBlur } }) => (
                <NumericFormat
                    {...numberFormatProps}
                    placeholder={placeholder}
                    onValueChange={(v) => onChange(v.value)}
                    value={value}
                    customInput={Input}
                    $optional={optional}
                    disabled={disabled}
                    onBlur={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomBlur ? onCustomBlur?.(ev) : onBlur();
                    }}
                    onFocus={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomFocus?.(ev);
                    }}
                />
            )}
        />
    );
};
